import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    protoOf($).n3r = get_window;
    initMetadataForCompanion($, VOID, [WindowFunctions()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function get_window() {
  return window;
}
var WindowFunctionsClass;
function WindowFunctions() {
  if (WindowFunctionsClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'WindowFunctions');
    WindowFunctionsClass = $;
  }
  return WindowFunctionsClass;
}
function requireConfirmation(_this__u8e3s4, confirmMessage, windowFunctions) {
  windowFunctions = windowFunctions === VOID ? Companion_instance : windowFunctions;
  return () => {
    var tmp;
    if (windowFunctions.n3r().confirm(confirmMessage)) {
      tmp = _this__u8e3s4();
    }
    return Unit_instance;
  };
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  requireConfirmation as requireConfirmation2wdsnfqvt1ik2,
  Companion_instance as Companion_instance3bj6fgbzlmvdz,
};
//endregion

//# sourceMappingURL=WindowFunctions.mjs.map
